import { observer } from "mobx-react-lite";
import './StepsHeader.scss'
import CircularProgress from "./CircularProgress";
import { store } from "../stores/Store";


const StepsHeader = observer(({ step }) => {

    const isMattressActive = store.sortedStepsFlat.find((step) => step.type === 'mattress')?.active;
    const isMattressActive2 = store.sortedStepsFlat.find((step) => step.type === 'mattress_toppers')?.active;

    return (
        <div className="StepsHeader">
            <div className="row">
                <div className="col-5">

                    <span className="StepsHeader__name">{store.product?.name || '...'}</span>
                </div>
                <div className="col-7 StepsHeader__steps">
                    {store.groups.map((group, index) => {
                        const isActive = group.steps.filter((step) => step.active).length > 0;
                        return (
                            <div key={index} className={`StepsHeader__step ${isActive || index == 0 ? 'active' : ''}`}>{index + 1}. {group.name} <span></span></div>
                        )
                    })}
                    {/* <div className="StepsHeader__step active">1. Konfiguracja łóżka <span></span></div> */}
                    {/* <div className={`StepsHeader__step ${(isMattressActive || isMattressActive2) ? 'active' : ''}`}>2. Dodatkowe akcesoria <span></span></div> */}
                </div>
            </div>

        </div>
    )
})
StepsHeader.displayName = 'StepsHeader'



export default StepsHeader